import React from 'react'
import Form from 'components/common/Form'
import SEO from 'components/common/Seo'

export default () => (
  <>
    <SEO title="Login" />
    <Form form="login" />
  </>
)
